import { INITIAL_WHOLESALER_DATA } from '../constants';

export const getInitialFormData = (initialData = {}) => {
    const data = {
        ...INITIAL_WHOLESALER_DATA,
        ...initialData,
    };

    const defaultPlan =
        data.defaultWholesalerPlan || data.defaultPlan || data.defaultPlanID;

    if (defaultPlan && typeof defaultPlan === 'object') {
        data.defaultPlanID = data.defaultPlanID || defaultPlan.id;
        data.defaultPlan = defaultPlan;
    }

    if (!data.entityName && data.name) {
        data.entityName = data.name;
    }

    if (data.id && !data.wholesalerId) {
        data.wholesalerId = data.id;
    }

    if (!data.wholesalerBillingSettings) {
        data.wholesalerBillingSettings = { billingNotes: [] };
    }

    if (!Array.isArray(data.wholesalerBillingSettings.billingNotes)) {
        data.wholesalerBillingSettings.billingNotes = [];
    }

    return data;
};

export const transformFormDataForCreate = (formData) => ({
    isActive: formData.isActive ?? true,
    enabled: formData.enabled ?? true,
    name: formData.name,
    entityName: formData.entityName || formData.name,
    defaultPlanID: formData.defaultPlanID,
    businessNumber: formData.businessNumber,
    primaryContactName: formData.primaryContactName,
    primaryContactEmail: formData.primaryContactEmail,
    primaryContactPhone: formData.primaryContactPhone,
    accountsContactEmail: formData.accountsContactEmail,
    supportContactEmail: formData.supportContactEmail,
});

export const transformFormDataForUpdate = (formData) => {
    const cleanedData = { ...formData };

    if (typeof cleanedData.defaultPlan === 'string') {
        delete cleanedData.defaultPlan;
    }

    delete cleanedData.wholesalerId;

    return cleanedData;
};
